import { render, staticRenderFns } from "./QRCodeSetting.vue?vue&type=template&id=3f38f0fd"
import script from "./QRCodeSetting.vue?vue&type=script&lang=js"
export * from "./QRCodeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports